// React
import React, { Component } from "react";
import Transition from 'react-transition-group/Transition';

// Stores
import { PricingStore, CurrencyStore } from '../../Stores';

// Styles
import "./charts.css";
import "../../assets/css/animations.css";

// Utils
import { GoogleAnalytics } from '../../Utils';

// Libraries

/**********************************************************
 *    MobileDetails Component
 * 
 *  - 
 *  - 
 **********************************************************/

class MobileDetails extends Component {

    /**********************************************************
     *  Constructor
     **********************************************************/

    constructor(props) {

        super(props);

        this.state = {
            price : 0.00,
            change : '0.00',
            fav : 'icon-heart6 text-pink icon-button',
            emitter : null,
            emitterToken : null,
            show : true,
            overlays : {
                "EMA 20" : false,
                "EMA 50" : false,
                "Bollinger" : false
            }
        }

        this.favouriteChart = this.favouriteChart.bind(this);
    }

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, retrieve last known price for topic
    // and listen with emitter for updates
    componentDidMount() {

        //console.log('ChartDetails.componentDidMount()');

        this.setup(null);

    }

    // Determines whether or not component should update
    shouldComponentUpdate(nextProps, nextState) {
        
        if(nextProps.topic !== this.props.topic || nextState.price !== this.state.price
            || nextProps.fav !== this.state.fav)
            return true;
        else
            return false;

    }


    // When chart details updates, check if new topic exists
    // if so, remove old emitter and setup new emitter
    componentDidUpdate(prevProps, prevState) {

        //console.log('ChartDetails.componentDidUpdate()');

        // new topic
        if(this.props.topic !== prevProps.topic) {

            if(this.state.emitterToken !== null){

                console.log('Updating Emitter...');

                this.state.emitterToken.remove();

                this.setup(this.state.emitter);

            }

        }
       
    }


    // Remove the emitter listener
    componentWillUnmount() {

        if(this.state.emitterToken !== null)
            this.state.emitterToken.remove();

    }

/**********************************************************
 *  Functions
 **********************************************************/

    // If given an existing emitter, get initial price, generate token and 
    // start listening for updates
    setup(emitter) {
        
        const _this = this;

        this.getInitialPrice(this.props.topic)
            .then( (priceObj) => {

                if(emitter === null) {

                    if(this.state.emitterToken != null)
                        emitter = PricingStore.getEmitter([this.state.emitterToken]);
                    else
                        emitter = PricingStore.getEmitter([]);
                } 
                    

                const emitterToken = _this.streamPriceUpdates(emitter, _this.props.topic);

                _this.setState((prev, props) => {
                    return {
                        price : priceObj.price,
                        change : priceObj.change,
                        emitter : emitter,
                        emitterToken : emitterToken,
                        show : !_this.state.show
                    }
                });

            });

    }


    // Return the last price for a given topic
    getInitialPrice(topic) {

        //console.log('ChartDetails.getInitialPrice()');

        return PricingStore.getPrice(topic)
            .then( (priceObj) => {

                return priceObj;

            });

    }


    // Listen for price updates for topic with emitter
    streamPriceUpdates(emitter, topic) {
        
        //console.log('ChartDetails.streamPriceUpdates()');

        const _this = this;

        var emitterToken = emitter.addListener(topic, function(newPriceObj) {

            if(newPriceObj.id === topic) {

                _this.setState((prev, props) => {
                    return {
                        price: newPriceObj.price,
                        change: newPriceObj.change,
                        show : !_this.state.show
                    }
                });

            }
            else {
                //console.log('outdated emitter listener has been caught.');
            }

        });

        return emitterToken;

    }


    // Favourite a chart
    favouriteChart() {
    
        //console.log('Charts.selectCandle()');

        var newClass = '';

        if(this.state.fav === 'icon-heart5 text-pink icon-button swell')
            newClass = 'icon-heart6 text-pink icon-button swell2';
        else
            newClass = 'icon-heart5 text-pink icon-button swell';
        
        this.setState((prev, props) => {
            return {
                fav : newClass
            }
        });

        // Log event to GA
        GoogleAnalytics.newAction('Chart', 'Favourite', this.props.topic);
    }

    // Changes the chart type between candlestick and heikin ashi
    selectChartType = (type) => {
        this.props.onSelectChartType(type);
    }

    // Select an overlay and apply it to chart
    selectOverlay(overlay) {

        var status = !this.state.overlays[overlay];
        var ovs = this.state.overlays;

        ovs[overlay] = status;

        this.props.onSelectOverlay(overlay, status);

        this.setState((prev, props) => {
            return {
                overlays : ovs
            }
        });
    }

/**********************************************************
 *  Render
 **********************************************************/

    render() {

        //console.log('ChartDetails.render()');

        const quoteCurrency = this.props.topic.split("-")[2];
        const currencySymbol = CurrencyStore.getCurrencySymbol(quoteCurrency);

        var priceSize = 'chart-price-default';
        if(quoteCurrency === 'BTC' || quoteCurrency === 'ETH' || quoteCurrency === 'JPY')
            priceSize = 'chart-price-small';

        return (

            <Transition timeout={1000} in={!!this.state.show}>
            {(status) => (

                <div>
                    <div className="chart-price-holder-mobile">
                        {/*<div>
                            <i className={this.state.fav} onClick={this.favouriteChart}></i>
                        </div>*/}

                        <div className="btn-group">
                            <button type="button" className="btn text-white btn-flat btn-icon dropdown-toggle legitRipple" data-toggle="dropdown" aria-expanded="false" style={{padding:0}}>
                                <i className="icon-cog3 icon-button spin"></i> &nbsp;<span className="caret" style={{marginLeft:'-8px'}}></span>
                            </button>

                            <ul className="dropdown-menu dropdown-menu-left">
                                <li className="dropdown-header"><i className="icon-chart"></i>Chart Types</li> 
                                <li onClick={this.selectChartType.bind(this,'Candlestick')}><a href={null}><i className="icon-stats-bars4"></i> Candlestick</a></li>
                                <li onClick={this.selectChartType.bind(this,'Heikin-Ashi')}><a href={null}><i className="icon-stats-bars4"></i> Heikin-Ashi</a></li>
                                <li className="dropdown-header"><i className="icon-stats-dots"></i>Overlays</li>
                                {
                                    Object.keys(this.state.overlays).map( (overlay) => {
                                        return (<li key={overlay} onClick={() => this.selectOverlay(overlay)}><a href={null}>
                                        <i className={this.state.overlays[overlay] ? "text-pink icon-minus3" : "text-green icon-plus3"}></i>{overlay}</a></li>)
                                    })
                                }
                            </ul>
                        </div>
                        
                        <div className={`${priceSize} blinker blink-${status}`}>
                            <span className="price-symbol">{ currencySymbol }</span>{this.state.price}
                        </div>
                        <div className={`${priceSize} blinker blink-${status}`}>
                            {this.state.change}%     
                            <i className={this.state.change > 0 ? 'icon-arrow-up8 green-text left-pad arrow hover-up' : 'icon-arrow-down8 red-text left-pad arrow hover-down'}></i>
                        </div>
                            
                        <div>
                            <i className="icon-reload-alt text-white icon-button spin" onClick={this.props.refreshChart}></i>
                            </div>
                    </div>
                </div>

            )}
            </Transition>

        );
        
    }
}

export default MobileDetails;





// WEBPACK FOOTER //
// ./src/Views/Charting/MobileDetails.js